<div class="main-container-position mb-8">
  <div class="profile-banner">
    <h1 i18n>Ergebnisse für deine Suche</h1>
    <div class="cards-profile">
      <div class="filter-sidebar">
        <mat-card class="filter-style">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
              <li
                class="mat-tree-node hover:cursor-pointer"
                [ngClass]="{ 'highlight-filter': selectedNode === node }"
                >
                <mat-checkbox
                  [checked]="node.selected"
                  (change)="onCategoryToggle(node)"
                  class="text-sm"
                  >
                </mat-checkbox>
                <span class="text-sm">
                  {{ node.name }}
                </span>
              </li>
            </mat-tree-node>
            <mat-tree-node
              *matTreeNodeDef="let node; when: hasChild"
              matTreeNodeToggle
              >
              <div
                class="mat-tree-node text-sm hover:cursor-pointer"
                [ngClass]="{ 'highlight-filter': selectedNode === node }"
                >
                <button
                  class="text-sm"
                  mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.name"
                  >
                  <mat-icon class="mat-icon-rtl-mirror text-sm">
                    {{
                    treeControl.isExpanded(node)
                    ? "expand_more"
                    : "chevron_right"
                    }}
                  </mat-icon>
                </button>
                <span class="text-sm flex items-center">
                  {{ node.name }}
                  @if (getSelectedCount(node.type) > 0) {
                    <span
                      class="ml-2 px-2 py-0.5 text-xs rounded-full"
                    [ngClass]="{
                      'bg-green-100 text-green-700': node.type === 'category',
                      'bg-blue-100 text-blue-700': node.type === 'offerType'
                    }"
                      >
                      {{ getSelectedCount(node.type) }}
                    </span>
                  }
                </span>
              </div>
              <div
                [class.example-tree-invisible]="!treeControl.isExpanded(node)"
                >
                <ng-container matTreeNodeOutlet class="text-sm"></ng-container>
              </div>
            </mat-tree-node>
          </mat-tree>
        </mat-card>
      </div>
      <div class="ml-4 w-full">
        <div class="flex gap-4 md:flex-row flex-col">
          @if (searchProfiles.length > 0) {
            <mat-form-field
              appearance="fill"
              class="w-full md:w-5/6"
              >
              <mat-label i18n>Suchprofil auswählen</mat-label>
              <mat-select
                [(value)]="selectedProfileId"
                (selectionChange)="onProfileIdSelect($event.value)"
                >
                <mat-select-trigger>
                  <div class="flex items-center gap-2">
                    @if (selectedSearchProfile?.profilePicture) {
                      <img
                        [src]="selectedSearchProfile?.profilePicture"
                        alt="Profilbild"
                        class="w-6 h-6 rounded-full"
                        />
                    }
                    {{ selectedSearchProfile?.name || "Individuell" }}
                  </div>
                </mat-select-trigger>
                <mat-option [value]="'individual'" i18n>Individuell</mat-option>
                @for (profile of searchProfiles; track profile.id) {
                  <mat-option [value]="profile.id">
                    <div class="flex items-center gap-2">
                      <img
                        [src]="profile.profilePicture"
                        alt="Profilbild"
                        class="w-6 h-6 rounded-full"
                        />
                      {{ profile.name }}
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <!-- Postal code input field in top area -->
          <mat-form-field class="w-full md:w-fit">
            <mat-label>PLZ hinzufügen</mat-label>
            <input
              matInput
              placeholder=""
              #postalCodeInput
              (keydown.enter)="
                addPostalCodeFromInput(postalCodeInput.value);
                postalCodeInput.value = ''
              "
              />
            <button
              matSuffix
              mat-icon-button
              (click)="
                addPostalCodeFromInput(postalCodeInput.value);
                postalCodeInput.value = ''
              "
              >
              <mat-icon>add</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="flex flex-col gap-4 md:pb-4 z-0">
          <div class="flex flex-wrap gap-4 items-center">
            <mat-chip-set class="flex flex-wrap gap-4 z-0">
              @for (tag of tags; track tag) {
                <mat-chip
                  role="listitem"
                  [ngClass]="getTagColorClass(tag.type)"
                  [removable]="true"
                  >
                  {{ tag.name }}
                  <button
                    matChipRemove
                    aria-label="Remove tag"
                    (click)="onRemoveTag(tag)"
                    >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </mat-chip-set>
          </div>

          <div
            class="flex flex-wrap gap-4 md:pl-4 md:pb-4 z-0 relative md:justify-start justify-center"
            >
            @if (isLoading) {
              <div
                @fadeInOut
                class="absolute inset-0 bg-gray-50/80 flex items-center justify-center z-10"
                >
                <span class="text-gray-600" i18n>Lade Daten ...</span>
              </div>
            }

            @if (!isLoading && offers.length === 0) {
              <div
                @fadeInOut
                class="w-full text-center py-8"
                >
                <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
                  <div class="flex items-center">
                    <span class="material-symbols-outlined text-blue-500 mr-3"
                      >info</span
                      >
                      <p class="text-gray-700" i18n>
                    Wir haben in deiner Region und für deinen Filter leider noch
                    keine Angebote. <br />
                    Schreib uns eine Nachricht an
                    <a href="mailto:office@sondis.at">office&#64;sondis.at</a>
                    und wir arbeiten daran, das zu ändern!
                  </p>
                    </div>
                  </div>
                </div>
              }
              @for (offer of offers; track offer) {
                <app-offer-card
                  class="max-w-[231px] w-full"
                  [offer]="offer"
                  [showStatus]="false"
                  [showActions]="false"
                  [showContextMenu]="false"
                  [fromAdvisoryBoard]="false"
                ></app-offer-card>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
